import React from "react";
import style from '../pricing.module.scss';
import toPersianNumber from '../../../helpers/actions/toPersianNumber'

const PricingColoredFilters = (props) => {

    return (
        <React.Fragment>
            <div className={style.newFilterHeaderWrapper}>
                {props.listFilters.map((filterItem, index) =>
                    <div
                        key={index}
                        className={`${style.filterHeaderItem} ${props.filters.productsListFilters.includes(filterItem.tag) ? style[filterItem.activeIcon] : style[filterItem.icon]}`}
                        onClick={() => props.handleProductListFilters(filterItem.tag, filterItem)}
                    >
                        {toPersianNumber(props.detailFilters[filterItem.tag])} {filterItem.label}
                    </div>
                )}
                {props.filters.productsListFilters.length > 0 &&
                    <div
                        className={`${style.filterHeaderItem} ${style.allItem}`}
                        onClick={() => { props.handleProductListFilters('allItems', props.listFilters); props.handleDeleteAll() }}
                    >
                        نمایش همه تنوع‌ها
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default PricingColoredFilters